export const removeUsersWithoutResumeFromQuery = (dynamicQuery) => {
  const hasResumesFilter = { upload_docs: { hex_content: { _is_null: false } } };
  if (!dynamicQuery) return hasResumesFilter;
  return { _and: [dynamicQuery, hasResumesFilter] };
};
